import React from "react";
import { Badge } from "@shopify/polaris";

export const statusTextMap: Record<string, string> = {
  pre_processing: "Pre-processing",
  processing: "Processing",
  failed_pre_processing: "Validation Failed",
  partially_successful_processing: "Partially Processed",
  failed_processing: "Failed Processing",
  successful_pre_processing: "Validated",
  successful_processing: "Processed",
};

export const badgeStatusMap: Record<string, React.ComponentProps<typeof Badge>["status"]> = {
  pre_processing: "info",
  processing: "info",
  failed_pre_processing: "critical",
  partially_successful_processing: "attention",
  successful_pre_processing: "success",
  successful_processing: "success-strong-experimental",
  failed_processing: "critical-strong-experimental",
};

export const uploadsTableColumns = {
  fileName: { name: "File name", filtering: false, sorting: false, paginatedValue: "fileName", disabled: false },
  status: { name: "Status", filtering: false, sorting: false, paginatedValue: "status", disabled: false },
  actions: {
    name: "Actions",
    filtering: false,
    sorting: false,
    disabled: false,
  },
  uploadedFiles: {
    name: "Uploaded File",
    filtering: false,
    sorting: false,
    disabled: false,
  },
};

export const blockedStatuses = ["pre_processing", "processing"];

export const dromoMigrationSchemaId = "3881e1b4-2ce6-45dc-9a44-f187b24faff3";
export const dromoBulkUpdateNextOrderDateSchemaId = "346992ea-c56d-422f-b7f5-e9e35673a84e";
export const dromoBulkUpdateSellingPlanSchemaId = "c0eff200-98f1-4b10-8f57-b5db3b4ab092";

export const dromoLicenseKey = "7ae29ef2-c0f0-4582-9247-ee8008520456";

export const bulkUpdatesEndpointsMap = {
  nextOrderDate: "/bulk-actions/update-next-order",
  sellingPlan: "/bulk-actions/swap-selling-plan",
};
